export default __webpack_public_path__ + "static/media/Riot-Stat-Project.c41c965b.pdf";